import React from 'react';

export function updateDateByTimeZone(attendanceHistories, timeZone) {
  return attendanceHistories.map((historyItem) => {
    const actionDate = formatDate(historyItem.actionTime, 'YYYY-MM-DD');
    const actionTime = formatDate(historyItem.actionTime, 'HH:mm:ss');
    const updatedActionTime = <span>{actionDate}<br />{actionTime}</span>;
    const sessionDay = formatDate(historyItem.sessionDuration.start, 'YYYY-MM-DD');
    const sessionStartTime = formatDate(historyItem.sessionDuration.start, 'HH:mm');
    const sessionEndTime = formatDate(historyItem.sessionDuration.end, 'HH:mm');
    const updatedSessionDurationTime = <span>{sessionDay}<br />{`${sessionStartTime} - ${sessionEndTime}`}</span>;
    return historyItem
      .set('actionTime', updatedActionTime)
      .set('sessionDuration', updatedSessionDurationTime);
  });

  function formatDate(momentDate, customFormat) {
    return momentDate.clone().tz(timeZone).format(customFormat);
  }
}

export default updateDateByTimeZone;



// WEBPACK FOOTER //
// ./data/AttendanceHistory/accessors.jsx